import axios from 'axios'
import ParamUtils from '@/core/utils/ParamUtils'

class LicitacaoApiClient {
    
    async buscarParametros() {
        return axios.get('/licitacao/api/public/v1/parametros-publicos')
    }
    
    async buscarLicitacoesPublicas(filtros, paginacao){
        return axios.get('/licitacao/api/public/v1/licitacoes/?'+
            ParamUtils.ObjectsToParams([paginacao, filtros])
        )
    }
    
    async buscarDadosGeraisLicitacao(licitacaoId){
        return axios.get(`/licitacao/api/public/v1/licitacoes/${licitacaoId}`)
    }
    
    async buscarAnexosEdital(licitacaoId){
        return axios.get(`/licitacao/api/public/v1/licitacoes/${licitacaoId}/anexos`)
    }

    async baixarAtaPublica(licitacaoId) {
        return axios.get(`/licitacao/api/public/v1/licitacoes/${licitacaoId}/ata`,
            {
                responseType: 'arraybuffer'
            })
    }

    async buscarAcompanhamentoApi(licitacaoId) {
        return axios.get(`/licitacao/api/public/v1/licitacoes/${licitacaoId}/acompanhamento`, licitacaoId)
    }

    async buscarAcompanhamentoDetalheApi(licitacaoId, loteId) {
        return axios.get(`/licitacao/api/public/v1/licitacoes/${licitacaoId}/acompanhamento/detalhe/${loteId}`, licitacaoId, loteId)
    }

    async buscarFornecedoresLoteApi(licitacaoId, loteId) {
        return axios.get(`/licitacao/api/public/v1/licitacoes/${licitacaoId}/lotes/${loteId}/fornecedores`)
    }

    async buscarDocumentosVencedorLoteApi(licitacaoId, loteId, fornecedorId) {
        return axios.get(`/licitacao/api/public/v1/licitacoes/${licitacaoId}/lotes/${loteId}/vencedor/documentos`, {params: {fornecedorId}})
    }

    async baixarDocumentoVencedorLoteApi(licitacaoId, loteId, tipoDocumento, fornecedorId, headers) {
        return axios.get(`/licitacao/api/public/v1/licitacoes/${licitacaoId}/lotes/${loteId}/vencedor/${tipoDocumento}`, {
            params: {fornecedorId},
            headers,
            responseType: 'arraybuffer'
        })
    }

    async solicitarEsclarecimentoImpugnacaoApi(payload) {
        const formData = new FormData()
        if (payload.anexo) {
            formData.append('anexo', payload.anexo)
        }
        payload.anexo = null
        formData.append('input', new Blob([JSON.stringify(payload)], {type: 'application/json'}))
        return axios.post(`/licitacao/api/public/v1/licitacoes/${payload.licitacaoId}/esclarecimentoImpugnacao`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
    
    async buscarEsclarecimentosImpugnacoes(licitacaoId){
        return axios.get(`/licitacao/api/public/v1/licitacoes/${licitacaoId}/esclarecimentosImpugnacoes`)
    }
    
    async buscarRespostasEsclarecimentoImpugnacao(esclarecimentoImpugnacaoId){
        return axios.get(`/licitacao/api/public/v1/licitacoes/${esclarecimentoImpugnacaoId}/respostas`)
    }
    
    async validarCodigoEmail(token){
        return axios.post('/licitacao/api/public/v1/confirmar-escl-impug/', {token})
    }

    async buscarMunicipios(estadoSigla){
        return axios.get(`/licitacao/api/public/licitacoes/buscarMunicipiosPorEstado/${estadoSigla}`)
    }

    async buscarProcessos(paginacao){
        return axios.get('/licitacao/api/public/licitacoes/?'+
            ParamUtils.ObjectsToParams([paginacao])
        )
    }

    async buscarUnicoProcessoLicitacao(processoId){
        return axios.get(`/licitacao/api/licitacao/public/portal/paginaInterna/idLicitacao=${processoId}`)
    }

    async buscarLotesPaginaInterna(processoId, paginacao){
        return axios.get(`/licitacao/api/licitacao/public/portal/paginaInterna/lotes/idLicitacao=${processoId}?`+
            ParamUtils.ObjectsToParams([paginacao])
        )
    }

    async baixarArquivo(payload, headers){
        return axios.get(
            '/licitacao/api/v1/filemanager/download?' +
            ParamUtils.ObjectsToParams([payload]),
            {
                headers: headers,
                responseType: 'arraybuffer'
            }
        )
    }

    async gerarXMLPropostaPresencial(payload){
        return axios.post('/licitacao/api/public/licitacoes/presencial/gerar-arquivo-proposta', payload)
    }

    async buscarListagemSimularProposta(licitacaoId) {
        return axios.get(`/licitacao/api/public/licitacoes/presencial/${licitacaoId}/simular-proposta`, licitacaoId)
    }

    async buscarImagensItemBase64(itemId) {
        return axios.get(`/licitacao/api/public/licitacoes/itens/${itemId}/imagens/base64`)
    }

    async buscarImagensLoteLicitacao(licitacaoId) {
        return axios.get(`/licitacao/api/public/licitacoes/${licitacaoId}/imagens`)
    }

}

export default new LicitacaoApiClient()
